import React from 'react';
import { Container, Header, Segment } from 'semantic-ui-react';
import { Helmet } from 'react-helmet';
import { SITE_BASE_URL } from '../services/api';
import { DISCLAIMER_TEXT } from '../constants/disclaimer';
import DisclaimerLink from './DisclaimerLink';

const baseUrl = SITE_BASE_URL.replace(/\/$/, '');
const canonicalUrl = `${baseUrl}/disclaimer`;
const title = 'Disclaimer - Blue Compass RV Technical Support';
const description = 'Disclaimer for Blue Compass RV customer support transcripts and troubleshooting content. Read before using transcript information.';

const DisclaimerPage = () => {
  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
      </Helmet>
      <main>
      <Container style={{ padding: '20px', maxWidth: '900px', marginBottom: '40px' }}>
        <p style={{ marginBottom: '20px' }}>
          <DisclaimerLink />
        </p>
        <Header as="h1" style={{ marginTop: '30px', marginBottom: '20px' }}>
          Disclaimer
        </Header>
        <Segment style={{ padding: '24px', lineHeight: '1.6', fontSize: '14px' }}>
          {DISCLAIMER_TEXT.split(/\n\n+/).map((paragraph, i) => {
            const isHeading = /^[A-Z][A-Z\s.]+$/.test(paragraph.trim()) && paragraph.trim().length < 60;
            return (
              <p
                key={i}
                style={{
                  marginBottom: '1em',
                  marginTop: isHeading ? '1.25em' : 0,
                  fontWeight: isHeading ? 600 : 400,
                }}
              >
                {paragraph.trim()}
              </p>
            );
          })}
        </Segment>
      </Container>
      </main>
    </>
  );
};

export default DisclaimerPage;
